module.exports = {
      id: "ic-fractal-chaos-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-fractal-chaos-usage",
      toString: function () {
        return this.url;
      }
    }